import { Dispatch } from 'react';

import { Action } from '@/legacy/utils/reactHelpers';

import { ActionType } from './LoginPopupMultiple.reducer';

interface ActionCallbacks {
  onSubmitCode: () => void;
  onClose: () => void;
  onClearInput: () => void;
}

function handleQueries(
  queries: Array<Action<ActionType>>,
  dispatch: Dispatch<Action<ActionType>>,
  callbacks: ActionCallbacks
): void {
  queries.forEach(async (query) => {
    switch (query.type) {
      case ActionType.QuerySubmitCode: {
        callbacks.onSubmitCode();
        break;
      }
      case ActionType.QueryClosePopup: {
        callbacks.onClose();
        break;
      }
      case ActionType.QueryClearInput: {
        callbacks.onClearInput();
        break;
      }
    }
  });
}

export default handleQueries;
export { ActionCallbacks };
